import { combineReducers } from '@reduxjs/toolkit';
import auth from './auth';
import transactions from './transactions';
import trxSearch from './trxSearch';
import programSales from './programSales';
import payment from './payment';
import purchaseOrder from './purchaseOrder';
import salesReports from './salesReports';
import programSalesReports from './programSalesReports';
import glJournal from './glJournal';
import bankReports from './bankReport';
import trxUser from './trxUser';

export default combineReducers({
  auth,
  transactions,
  trxSearch,
  trxUser,
  programSales,
  payment,
  purchaseOrder,
  salesReports,
  programSalesReports,
  glJournal,
  bankReports,
});
